module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "toc-title"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/04_Chronology"
    }
  }, [_vm._v("A Mostly Somewhat Putative Chronology")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocb"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Introduction"
    }
  }, [_vm._v("Introduction and Prefatory Remarks")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Chapter01"
    }
  }, [_c('span', {
    staticClass: "tocc"
  }, [_vm._v("Chapter 1")]), _vm._v(" Aeneas’ Escape From Troy")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocc"
  }, [_vm._v("Chapter 2")]), _vm._v(" Dido, Queen of Carthage")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocc"
  }, [_vm._v("Chapter 3")]), _vm._v(" A Visit to the Land of the Dead")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocc"
  }, [_vm._v("Chapter 4")]), _vm._v(" The Trojans Arrive in Hesperia")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocc"
  }, [_vm._v("Chapter 5")]), _vm._v(" Romulus Founds Rome")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocc"
  }, [_vm._v("Chapter 6")]), _vm._v(" The Sabine Women Intervene")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocc"
  }, [_vm._v("Chapter 7")]), _vm._v(" The Horatii Save Rome")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocc"
  }, [_vm._v("Chapter 8")]), _vm._v(" An Immigrant Becomes King")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocc"
  }, [_vm._v("Chapter 9")]), _vm._v(" Tarquin the Proud")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocc"
  }, [_vm._v("Chapter 10")]), _vm._v(" The Rape of Lucretia")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocc"
  }, [_vm._v("Chapter 11")]), _vm._v(" Brutus Becomes Consul")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocc"
  }, [_vm._v("Chapter 12")]), _vm._v(" Horatius Defends the Bridge")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocc"
  }, [_vm._v("Chapter 13")]), _vm._v(" Lars Porsena Learns a Thing or Two About the Romans")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocc"
  }, [_vm._v("Chapter 14")]), _vm._v(" Coriolanus Banishes Rome")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocc"
  }, [_vm._v("Chapter 15")]), _vm._v(" Cincinnatus, Dictator for Fifteen Days")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocc"
  }, [_vm._v("Chapter 16")]), _vm._v(" An Honour Killing")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocc"
  }, [_vm._v("Chapter 17")]), _vm._v(" A Schoolteacher’s Humiliation")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocc"
  }, [_vm._v("Chapter 18")]), _vm._v(" The Gauls Invade")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocc"
  }, [_vm._v("Chapter 19")]), _vm._v(" Hard Cheese, Losers!")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocc"
  }, [_vm._v("Chapter 20")]), _vm._v(" Sacred Chickens, Et Cetera")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocc"
  }, [_vm._v("Chapter 21")]), _vm._v(" The Die is Cast!")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocc"
  }, [_vm._v("Chapter 22")]), _vm._v(" The Ides of March")])]), _vm._v(" "), _c('h2', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Reading",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Further Reading")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a01b224c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 69
// module chunks = 0